import {
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL,
  RESET_PROFILE_STATE,
  GET_PROFILE_DATA_BY_TAB_SUCCESS,
  GET_PROFILE_DATA_BY_TAB_FAIL,
  CREATE_SALESMAN_SUCCESS,
  CREATE_SALESMAN_FAIL,
  RESET_PROFILE_ACTION_STATE,
  DELETE_SALESMAN_SUCCESS,
  DELETE_SALESMAN_FAIL,
  SET_SALESMAN_AS_DEFAULT_SUCCESS,
  SET_SALESMAN_AS_DEFAULT_FAIL,
  REMOVE_TEAM_MEMBER_SUCCESS,
  REMOVE_TEAM_MEMBER_FAIL,
  INVITE_TEAM_MEMBER_SUCCESS,
  INVITE_TEAM_MEMBER_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  profile: [],
  editProfile: [],
  editUserPwd: [],
}

const User = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROFILE_DATA_BY_TAB_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      }

    case GET_PROFILE_DATA_BY_TAB_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        editProfile: action.payload,
        profile: action.payload.data,
      }

    case UPDATE_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
        editProfile: action.payload,
      }

    case CREATE_SALESMAN_SUCCESS:
      return {
        ...state,
        createSalesman: action.payload,
      }

    case CREATE_SALESMAN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_SALESMAN_SUCCESS:
      return {
        ...state,
        deleteSalesman: action.payload,
      }

    case DELETE_SALESMAN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case SET_SALESMAN_AS_DEFAULT_SUCCESS:
      return {
        ...state,
        setSalesmanAsDefault: action.payload,
      }

    case SET_SALESMAN_AS_DEFAULT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case REMOVE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        removeTeamMember: action.payload,
      }

    case REMOVE_TEAM_MEMBER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case INVITE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        inviteTeamMember: action.payload,
      }

    case INVITE_TEAM_MEMBER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_PROFILE_STATE:
      return {
        ...state,
        profile: [],
        editProfile: [],
        createSalesman: [],
        deleteSalesman: [],
        setSalesmanAsDefault: [],
        removeTeamMember: [],
        inviteTeamMember: [],
        error: [],
      }
    case RESET_PROFILE_ACTION_STATE:
      return {
        ...state,
        editProfile: [],
        createSalesman: [],
        deleteSalesman: [],
        setSalesmanAsDefault: [],
        removeTeamMember: [],
        inviteTeamMember: [],
        error: [],
      }
    default:
      return state
  }
}

export default User
